<template>
  <div class="flash notification" :class="[
        typeClass, isOpen ? isVisibleClass : ''
    ]">
    <svg
      @click="isOpen = false"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="delete"
      v-show="showClose"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "Notification",
  data() {
    return {
      isOpen: false,
      isVisibleClass: "is-visible",
      closeAfter: 5000, // 10 seconds, you can change that
      typeClass: "info",
      message: null,
      showClose: false
    };
  },
  created() {
    this.$bus.$on("notify", $event => {
      this.flash($event);
    });
  },
  methods: {
    flash(data) {
      if (data) {
        this.message = data.message;
        this.typeClass = `is-${data.type}`;
      }

      setTimeout(() => {
        this.isOpen = true;
      }, 100);

      this.hide();
    },
    hide() {
      setTimeout(() => {
        this.isOpen = false;
      }, this.closeAfter);
    }
  }
};
</script>

<style lang="scss" scoped>
.flash.notification {
  z-index: 99999999999;
  position: fixed;
  top: 10px;
  left: 50%;
  opacity: 0;
  transform: translateY(-100%) translateX(-50%);
  transition: all 0.4s ease-in-out;
  background: var(--dark-blue);
  color: #fff;
  padding: 10px 20px;
  border-radius: 2px;

  &.is-visible {
    transform: translate(-50%);
    opacity: 1;
  }

  .delete {
    max-width: 15px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>